import { PMLineChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import {
  getCompletedItemsDataAndCategories,
  TIMEFRAME_OPTIONS,
} from "../../../utils/getCompletedItemsByTimeframe";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCompletedItemsOverTimeCard(ctx: DashboardCardContext) {
  const { view, getCardCopy } = ctx;

  const completedItemsOverTimeComponent = view.addComponent({
    component: PMLineChartCard,
    layoutProps: {
      componentId: "completedItemsOverTimeComponent",
      title: "",
      description: "",
      labels: ["lineChart", "chart", "completedItemsOverTimeComponent"],
    },
  });

  completedItemsOverTimeComponent.mapLayoutProps(({ language }) => ({
    componentId: "completedItemsOverTimeComponent",
    labels: ["lineChart", "chart", "completedItemsOverTimeComponent"],
    title: getCardCopy(language, "completedItemsOverTime").title,
    description: getCardCopy(language, "completedItemsOverTime").description,
  }));

  completedItemsOverTimeComponent.mapState((appState) => {
    const completedItemsOverReportingCycle =
      appState?.dashboard?._calculated?.completedItemsOverReportingCycle;
    const language = appState?.language;
    const reportingCycle = appState?.settings?.configuration?.reportingCycle;
    const { data, categories } = getCompletedItemsDataAndCategories(
      completedItemsOverReportingCycle
    );

    return {
      title: getCardCopy(language, "completedItemsOverTime").title,

      timespans: TIMEFRAME_OPTIONS,
      data,
      categories,
      xLabel: getLocalizedMessage(language, "time") || "Time",
      yLabel:
        getLocalizedMessage(language, "completedItems") || "Completed Items",
      reportingCycle,
    };
  });

  completedItemsOverTimeComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
